import { IStore } from '../reducers'

export const shipmentStateSelector = (state: IStore) => state.shipmentData
export const pathStateSelector = (state: IStore) => state.path
